// Do not modify this file by hand!
// Re-generate this file by running lit-localize.

/**
 * The locale code that templates in this source code are written in.
 */
export const sourceLocale = `en`;

/**
 * The other locale codes that this application is localized into. Sorted
 * lexicographically.
 */
export const targetLocales = [
  `af`,
  `am`,
  `ar`,
  `ay`,
  `az`,
  `be`,
  `bg`,
  `bi`,
  `bn`,
  `bs`,
  `ca`,
  `ch`,
  `cs`,
  `cy`,
  `da`,
  `de`,
  `dv`,
  `dz`,
  `el`,
  `en`,
  `es`,
  `et`,
  `eu`,
  `fa`,
  `fi`,
  `fj`,
  `fr`,
  `ga`,
  `gd`,
  `gl`,
  `gn`,
  `gv`,
  `he`,
  `hi`,
  `ho`,
  `hr`,
  `ht`,
  `hu`,
  `hy`,
  `id`,
  `is`,
  `it`,
  `ja`,
  `ka`,
  `kk`,
  `kl`,
  `km`,
  `ko`,
  `ku`,
  `ky`,
  `la`,
  `lb`,
  `lo`,
  `lt`,
  `lv`,
  `mg`,
  `mh`,
  `mi`,
  `mk`,
  `mn`,
  `ms`,
  `mt`,
  `my`,
  `na`,
  `nb`,
  `nd`,
  `ne`,
  `nl`,
  `nr`,
  `ny`,
  `pap`,
  `pl`,
  `prs`,
  `ps`,
  `pt`,
  `qu`,
  `rn`,
  `ro`,
  `ru`,
  `rw`,
  `sg`,
  `si`,
  `sk`,
  `sl`,
  `sm`,
  `sn`,
  `so`,
  `sq`,
  `sr`,
  `ss`,
  `st`,
  `sv`,
  `sw`,
  `ta`,
  `tg`,
  `th`,
  `ti`,
  `tk`,
  `tl`,
  `tn`,
  `to`,
  `tr`,
  `ts`,
  `uk`,
  `ur`,
  `uz`,
  `ve`,
  `vi`,
  `xh`,
  `zh`,
  `zu`,
] as const;

/**
 * All valid project locale codes. Sorted lexicographically.
 */
export const allLocales = [
  `af`,
  `am`,
  `ar`,
  `ay`,
  `az`,
  `be`,
  `bg`,
  `bi`,
  `bn`,
  `bs`,
  `ca`,
  `ch`,
  `cs`,
  `cy`,
  `da`,
  `de`,
  `dv`,
  `dz`,
  `el`,
  `en`,
  `en`,
  `es`,
  `et`,
  `eu`,
  `fa`,
  `fi`,
  `fj`,
  `fr`,
  `ga`,
  `gd`,
  `gl`,
  `gn`,
  `gv`,
  `he`,
  `hi`,
  `ho`,
  `hr`,
  `ht`,
  `hu`,
  `hy`,
  `id`,
  `is`,
  `it`,
  `ja`,
  `ka`,
  `kk`,
  `kl`,
  `km`,
  `ko`,
  `ku`,
  `ky`,
  `la`,
  `lb`,
  `lo`,
  `lt`,
  `lv`,
  `mg`,
  `mh`,
  `mi`,
  `mk`,
  `mn`,
  `ms`,
  `mt`,
  `my`,
  `na`,
  `nb`,
  `nd`,
  `ne`,
  `nl`,
  `nr`,
  `ny`,
  `pap`,
  `pl`,
  `prs`,
  `ps`,
  `pt`,
  `qu`,
  `rn`,
  `ro`,
  `ru`,
  `rw`,
  `sg`,
  `si`,
  `sk`,
  `sl`,
  `sm`,
  `sn`,
  `so`,
  `sq`,
  `sr`,
  `ss`,
  `st`,
  `sv`,
  `sw`,
  `ta`,
  `tg`,
  `th`,
  `ti`,
  `tk`,
  `tl`,
  `tn`,
  `to`,
  `tr`,
  `ts`,
  `uk`,
  `ur`,
  `uz`,
  `ve`,
  `vi`,
  `xh`,
  `zh`,
  `zu`,
] as const;
